import { apiRequest } from "./client";

export type Role = "super_admin" | "admin";

export type LoginResponse = {
  username: string;
  access_token: string;
  token_type: string;
  expires_in: number;
  role: Role;
  must_change_password: boolean;
};

/** /me returns 200 with `username: null` when the visitor has no session. */
export type MeResponse = {
  username: string | null;
  role: Role | null;
  must_change_password: boolean;
};

export type LogoutReason = "manual" | "inactivity";

export type DailyTimeResponse = {
  today_ist: string; // YYYY-MM-DD
  accumulated_seconds: number;
  active_session_started_at: string | null;
};

export function login(username: string, password: string) {
  return apiRequest<LoginResponse>("/auth/login", {
    method: "POST",
    body: { username, password },
  });
}

export function logout(reason: LogoutReason = "manual") {
  return apiRequest<{ ok: boolean }>("/auth/logout", {
    method: "POST",
    headers: { "X-Logout-Reason": reason },
  });
}

export function me() {
  return apiRequest<MeResponse>("/auth/me");
}

export function heartbeat() {
  return apiRequest<{ ok: boolean }>("/auth/heartbeat", { method: "POST" });
}

export function dailyTime() {
  return apiRequest<DailyTimeResponse>("/auth/daily-time");
}
